const imageFiles = ['jpg','gif','png','jpeg','bmp', 'heic', 'heif'];
const videoFiles = ['mp4', 'm4v', 'mov', 'wmv','avi'];

export default class Uploader {
	constructor (form, bucket) {
		this.form = form;
		this.bucket = bucket;
		this.input = bucket.querySelector('input[type="file"]');
		this.id = bucket.parentNode.id.trim();

		this.progressBar = bucket.querySelector('progress');
		this.label = bucket.querySelector('.label');
		this.fileList = bucket.querySelector('.file-list');

		this.dragEvents = [
			'drag',
			'dragstart',
			'dragend',
			'dragover',
			'dragenter',
			'dragleave',
			'drop'
		];

		this.input.addEventListener('change', (evt) => {
			this._upload(evt.target.files);
		});

		this.dragEvents.forEach(dragEvent => {
			bucket.addEventListener(dragEvent, (evt) => {
				evt.preventDefault();
				evt.stopPropagation();

				switch (dragEvent) {
					case 'dragover':
					case 'dragenter':
						this.bucket.classList.add('dragover');
						break;

					case 'dragleave':
					case 'dragend':
						this.bucket.classList.remove('dragover');
						break;

					case 'drop':
						this.bucket.classList.remove('dragover');
						this._upload(evt.dataTransfer.files);
						break;
				}
			});
		});

		// bad scoping! I know
		window.deleteFile = function (event, elementId, fileId) {
			document.getElementById(fileId).remove();
			this.form.attachments[elementId] = this.form.attachments[elementId].filter(file => {
				return file._id !== fileId;
			});
		}.bind(this);
	}

	renderFileList (attachmentData) {
		this.fileList.innerHTML = '';

		let output = attachmentData ? attachmentData.map(data => {
			return '<div class="file" id="'+ data._id +'">'+
				'<div class="icons">' +
					'<svg class="icon" viewBox="0 0 2048 2048">' +
						'<use xlink:href="/apps/webapps/next/global/blazer/icons/icons.svg#file-o"></use>' +
					'</svg>' +
					'<a onclick="deleteFile(event, \''+ this.id +'\', \''+ data._id + '\')">' +
						'<svg class="icon">' +
							'<use xlink:href="/apps/webapps/next/global/blazer/icons/icons.svg#trash-o"></use>' +
						'</svg>' +
					'</a>' +
				'</div>' +
				'<a target="_blank" href="' + data.url + '" class="name">' + data.name + '</a>' +
			'</div>'
		}).reduce((totalStr, str) => {
			return totalStr + str;
		}, '') : '';

		this.fileList.innerHTML = output;
	}

	_upload (files) {
		this.form.disableSubmit();
		for (var i = 0; i < files.length; i ++) {
			this.setupReader(files[i],this.sendRequest)
		}
	}

	setupReader(fileOrBlob,callback){
		let xhr = new XMLHttpRequest();
		let data = new FormData();

		xhr.upload.onprogress = (evt) => {
			if (evt.lengthComputable) {
				this.progressBar.max = evt.total;
				this.progressBar.value = evt.loaded;
			}
		};

		xhr.upload.onloadstart = (evt) => {
			this.progressBar.value = 0;
			this.label.style.display = 'none';
			this.progressBar.style.display = 'block';
		};

		xhr.upload.onloadend = (evt) => {
			this.progressBar.value = evt.loaded;
		};

		xhr.onreadystatechange = () => {
			this.label.style.display = 'block';
			this.progressBar.style.display = 'none';
			this.form.enableSubmit();

			if (xhr.status === 200 && xhr.readyState === 4) {
				let response = JSON.parse(xhr.response);

				if (response.errorFiles) {
					window.alert(`The file ${response.errorFiles} was not uploaded. This file type is not permitted for security reasons.`);
				}

				if (response.successFiles) {
					const files = response.successFiles;
					files.forEach(data => data.url = data.url);

					this.form.attachments[this.id] = this.form.attachments[this.id] ? this.form.attachments[this.id] : [];
					this.form.attachments[this.id] = this.form.attachments[this.id].concat(files);
					this.renderFileList(this.form.attachments[this.id]);
				}	
			}
		};
		const fileType = fileOrBlob.type.split('/')[1];
		if (imageFiles.indexOf(fileType) !== -1 || videoFiles.indexOf(fileType) !== -1) {
			data.append(fileOrBlob.name, fileOrBlob);
			callback(xhr,data)
		} else {
			const reader = new FileReader();
			reader.onload = function() {
				data.append('filenames',fileOrBlob.name);
				data.append('files', fileOrBlob.type + "," + reader.result.split(",")[1]);
				callback(xhr,data);
			};
			reader.readAsDataURL(fileOrBlob);
		}
	}

	sendRequest(xhr,data){
		xhr.open('POST', '/apps/api/files/upload');
		xhr.send(data);
	}
}



// WEBPACK FOOTER //
// ./src/main/webapps/features/form-builder/react/public/classes/uploader.js